if (!customElements.get("swiper-component")) {
  class SwiperComponent extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.sectionId = this.getAttribute('data-section-id');
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.onSectionUnload = this.onSectionUnload.bind(this);
      this.resizeObserver = null;
      this.debouncedResize = null;
    }

    connectedCallback() {
      this.init();
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      document.addEventListener('shopify:section:unload', this.onSectionUnload);
      this.observeResize();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      document.removeEventListener('shopify:section:unload', this.onSectionUnload);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      this.destroySwiper();
    }

    onSectionLoad(event) {
      if (event.detail.sectionId === this.sectionId) {
        this.init();
      }
    }

    onSectionUnload(event) {
      if (event.detail.sectionId === this.sectionId) {
        this.destroySwiper();
      }
    }

    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    observeResize() {
      if (this.resizeObserver) this.resizeObserver.disconnect();

      // Debounce function
      let timeout;
      this.debouncedResize = () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.refreshSwiper();
        }, 150); 
      };

      this.resizeObserver = new ResizeObserver(() => {
        this.debouncedResize();
      });

      this.resizeObserver.observe(this);
    }

    refreshSwiper() {
      this.init(); // re-init with new breakpoints
    }

    init() {
      this.destroySwiper();
      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const isTablet = window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches;
      let slidesPerView;
      if (isMobile) {
        slidesPerView = parseFloat(this.getAttribute('data-perpage-mobile')) || 1.2;
      } else if (isTablet) {
        slidesPerView = parseFloat(this.getAttribute('data-perpage-tablet')) || 3; 
      } else {
        slidesPerView = parseFloat(this.getAttribute('data-perpage-desktop')) || 4;
      }
      const spaceBetween = isMobile ? parseInt(this.getAttribute('data-gap-mobile')) || 10 : parseInt(this.getAttribute('data-gap-desktop')) || 0;
      const slidesPerGroup = isMobile ? parseInt(this.getAttribute('data-permove-mobile')) || 1 : parseInt(this.getAttribute('data-permove-desktop')) || 1;
      const showArrows = isMobile ? this.getAttribute('data-show-arrows-mobile') === 'true' : this.getAttribute('data-show-arrows-desktop') === 'true';
      const showPagination = isMobile ? this.getAttribute('data-show-pagination-mobile') === 'true' : this.getAttribute('data-show-pagination-desktop') === 'true';
      const enableAutoplay = this.getAttribute('data-enable-autoplay') === 'true';

      // Build swiper config
      const swiperConfig = {
        slidesPerView,
        slidesPerGroup,
        spaceBetween,
        grabCursor: true,
        simulateTouch: true,
        loop: false,
        speed: 600,
        autoplay: enableAutoplay
          ? {
            delay: 3000,
            disableOnInteraction: false,
          }
          : false,
        navigation: showArrows
          ? {
            nextEl: this.querySelector('.swiper-component__swiper-next'),
            prevEl: this.querySelector('.swiper-component__swiper-prev'),
          }
          : {},
        pagination: showPagination
          ? {
            el: this.querySelector('.swiper-component__pagination'),
            clickable: true,
          }
          : {},
      };

      this.swiper = new Swiper(swiperEl, swiperConfig);
    }
  }

  customElements.define('swiper-component', SwiperComponent);
}
